import { Combobox } from "@sentricmusic/ui";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useGetMyAccounts } from "@/api/queries";

export default function AccountFilter({ values, onValuesChange }) {
  const { t } = useTranslation("common");

  const { data: myAccounts } = useGetMyAccounts();

  const accountOptions = useMemo(() => {
    const accounts
      = myAccounts?.data?.artistaccounts
        ?? myAccounts?.artistaccounts
        ?? [];

    if (!Array.isArray(accounts))
      return [];

    return accounts.map(account => ({
      value: account.artistaccountcode ?? account.artistAccountCode,
      label: account.accountname ?? account.accountName,
    }));
  }, [myAccounts]);

  return (
    <Combobox
      customWidth
      triggerClassName="w-full"
      label={t("other:accounts", "Accounts")}
      placeholder={t("other:select-account", "Select account(s)...")}
      data={accountOptions}
      values={values}
      onValuesChange={onValuesChange}
      selectAllLabel={t("common:select-all", "Select all")}
      clearButton
      clearLabel={t("other:clear", "Clear")}
    />
  );
}
